export const ADD_WIDGET = 'ADD_WIDGET';
export const DEL_WIDGET = 'DEL_WIDGET';
export const DEL_TABS_WIDGET = 'DEL_TABS_WIDGET';
export const DEL_WIDGET_TAB = 'DEL_WIDGET_TAB';
export const UPDATE_WIDGET = 'UPDATE_WIDGET';
export const COPY_WIDGET = 'COPY_WIDGET';
export const UPDATE_WIDGET_VISIBLE = 'UPDATE_WIDGET_VISIBLE';

export const UPDATE_EDIT_PAGE_VISIBLE = 'UPDATE_EDIT_PAGE_VISIBLE ';

export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';

export const UPDATE_PAGE_INFO = 'UPDATE_PAGE_INFO';

export const UPDATE_LOADING = 'UPDATE_PAGE_LOADING';
export const UPDATE_SAVE_LOADING = 'UPDATE_SAVE_LOADING';
export const INSET_TITLE = 'INSET_TITLE';

export const UPDATE_MODIFIED = 'UPDATE_MODIFIED ';

export const UPDATE_COMPONENTS = 'UPDATE_COMPONENTS';

export const ADD_RECORD = 'ADD_RECORD';

export const UPDATE_FILTERS_GROUP = 'UPDATE_FILTERS_GROUP';

export const UPDATE_LINKAGE_FILTERS_GROUP = 'UPDATE_LINKAGE_FILTERS_GROUP';
export const DELETE_LINKAGE_FILTERS_GROUP = 'DELETE_LINKAGE_FILTERS_GROUP';
